import script from "./AdminAppSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminAppSelect.vue?vue&type=script&setup=true&lang=js"

import "./AdminAppSelect.vue?vue&type=style&index=0&id=41bcf0a4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41bcf0a4"]])

export default __exports__